import { IProductionReportSetting } from "shared/api/api";
import { Syncable } from "shared/state/models/syncable";


export const SAVE_PRODUCTION_REPORT_SETTING = 'SAVE_PRODUCTION_REPORT_SETTING';
export const SYNC_DATA_PRODUCTION_REPORT_SETTING = 'SYNC_DATA_PRODUCTION_REPORT_SETTING';

export interface ProductionReportSettingState extends Syncable<IProductionReportSetting> {}
